import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { Input, ButtonSecondary } from '../../../components'
import { requestOTPForgotPassword, setResetPasswordStep } from '../../../features/account/slice'
import { errorHandler, formUpdater, useViewport } from '../../../utils'

const DEFAULT_DATA = {
  // method 1 = email, method 2 = sms. ref: knowledge base.
  method: 1
}

const Form = (props) => {
  const dispatch = useDispatch()
  const [form, setForm] = React.useState(DEFAULT_DATA)
  const { isMobile } = useViewport()
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)
  const [requesting, setRequesting] = React.useState(false)

  const updateForm = (e) => formUpdater(e, form, setForm)

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log(form)

    if(form.email && requesting === false){
      setRequesting(true)

      dispatch(requestOTPForgotPassword(form))
        .then(res => {
          console.log('request otp res', res)
          if(!res.payload){
            const msg = errorHandler(res.error)
            toast.error(msg)
          } else {
            const message = res.payload?.message
            toast.success(message)
            dispatch(setResetPasswordStep(2))
          }
        })
        .catch(err => {
          toast.error(err)
        })
        .finally(() => {
          setRequesting(false)
        })
    } else {
      toast.error('Invalid form.')
    }
  }

  return (
    <form {...props} onSubmit={handleSubmit}>
      <Input required placeholder={translation.AUTH.email[language.name]} className="w-full mb-6 md:mb-8" type="email" name="email" onChange={updateForm}/>
      <ButtonSecondary isLoading={requesting} disabled={requesting} thin={isMobile} type="submit">
        {translation.AUTH.send_reset_link[language.name]}
      </ButtonSecondary>
    </form>
  )
}

export { Form }
